import React, { useEffect, useState } from 'react';
import { Avatar, Card, Col, PageHeader, Row, Tooltip } from 'antd';
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  HourglassOutlined,
} from '@ant-design/icons';
import firebase from 'firebase';
import { connect, useDispatch, useSelector } from 'react-redux';
import CustomContent from '../../../components/Content/CustomContent';
import WrappedSecurity from './Security';
import WrappedPersonalInfo from './PersonalInfo';
import './ProfilePage.less';
import AvatarUploader from './AvatarUploader';
import {
  getCurrentUserAction,
  saveAvatarAction,
} from '../../../actions/UserActions';
import { getDateTimeDisplayText } from '../../../utils/dateUtils';

const ProfilePage = () => {
  const dispatch = useDispatch();
  const [tabKey, setTabKey] = useState('personal');

  const { currentUser } = useSelector(store => ({
    currentUser: store.userReducer.currentUser,
  }));

  useEffect(() => {
    dispatch(getCurrentUserAction());
  }, []);

  const onTabChange = (key, type) => {
    
    setTabKey(key);
  };

  const onAvatarUpdate = url => {
    dispatch(
      saveAvatarAction(
        {
          avatarUrl: url,
        },
        currentUser.id,
      ),
    );
  };

  const tabList = [
    {
      key: 'personal',
      tab: 'Personal Details',
    },
    {
      key: 'security',
      tab: 'Security',
    },
  ];

  const contentList = {
    personal: <WrappedPersonalInfo currentUser={currentUser} />,
    security: <WrappedSecurity currentUser={currentUser} />,
  };

  return (
    <div>
      <Row>
        <CustomContent>
          <PageHeader
            style={{
              border: '1px solid rgb(235, 237, 240)',
            }}
            // onBack={handleBack}
            title="Profile"
            subTitle="User Management"
          />
        </CustomContent>
      </Row>
      <Row>
        <Col span={8}>
          <CustomContent>
            <Card>
              <Row type="flex" justify="center">
                <div className="avatar">
                  <AvatarUploader
                    storageRef={firebase
                      .storage()
                      .ref(
                        window.location.hostname.split('.')[0] + '/user-images',
                      )}
                    storageFolder={
                      window.location.hostname.split('.')[0] + '/user-images'
                    }
                    onAvatarUpdate={onAvatarUpdate}
                  >
                    <Avatar
                      size={180}
                      src={currentUser ? currentUser.avatarUrl : ''}
                      shape="circle"
                      // onClick={() => this.handleAvatarClicked(record.image)}
                    />
                  </AvatarUploader>
                </div>
              </Row>
              <br />
              <Row type="flex" justify="center">
                <b>
                  {currentUser && currentUser.name ? currentUser.name : '-'}
                </b>
              </Row>
              <Row type="flex" justify="center">
                {currentUser && currentUser.userGroup
                  ? currentUser.userGroup.value
                  : '-'}
              </Row>
              <br />
              <Row gutter={[16, 16]} style={{ display: 'flex' }}>
                <Col>
                  <Tooltip title="Email">
                    <MailOutlined />
                  </Tooltip>
                </Col>
                <Col>
                  {currentUser && currentUser.email ? currentUser.email : '-'}
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ display: 'flex' }}>
                <Col>
                  <Tooltip title="Phone Number">
                    <PhoneOutlined />
                  </Tooltip>
                </Col>
                <Col>
                  {currentUser && currentUser.phoneNumber
                    ? currentUser.phoneNumber
                    : '-'}
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ display: 'flex' }}>
                <Col>
                  <Tooltip title="Address">
                    <EnvironmentOutlined />
                  </Tooltip>
                </Col>
                <Col>
                  {currentUser && currentUser.address
                    ? currentUser.address
                    : '-'}
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ display: 'flex' }}>
                <Col>
                  <Tooltip title="Last Visit">
                    <HourglassOutlined />
                  </Tooltip>
                </Col>
                <Col>
                  {currentUser && currentUser.lastSeen
                    ? getDateTimeDisplayText(currentUser.lastSeen)
                    : '-'}
                </Col>
              </Row>
            </Card>
          </CustomContent>
        </Col>
        <Col span={16}>
          <CustomContent>
            <Card
              style={{ width: '100%' }}
              tabList={tabList}
              activeTabKey={tabKey}
              onTabChange={key => {
                onTabChange(key, 'tabKey');
              }}
            >
              {contentList[tabKey]}
            </Card>
          </CustomContent>
        </Col>
      </Row>
    </div>
  );
};
ProfilePage.propTypes = {
  // currentUser: PropTypes.object,
  // getCurrentUserAction: PropTypes.func,
  // saveAvatarAction: PropTypes.func,
};
function mapStateToProps({ userReducer }) {
  const { currentUser } = userReducer;
  return { currentUser };
}

export default connect(mapStateToProps, {
  getCurrentUserAction,
  saveAvatarAction,
})(ProfilePage);
